module.exports = __webpack_public_path__ + "img/JoeWahba_O_51.aadf2cdf.jpg";